module.exports = __webpack_public_path__ + "static/media/testimonials1.ecdc32ca.jpg";